import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import { AuthProvider } from '@/contexts/SupabaseAuthContext';
import { initDevelopmentHelpers } from '@/utils/developmentHelpers';
import { logger } from '@/config/production-logging';
import { initPerformanceOptimizations } from '@/utils/performanceOptimizer';
import resourcePreloader from '@/utils/resourcePreloader';
import { errorHandler } from '@/lib/errorHandler.jsx';
import navigationGuard from '@/lib/navigationGuard';
import '@/index.css';

// Initialize development helpers (only in development)
if (import.meta.env.DEV) {
  initDevelopmentHelpers();
}

// Initialize error handling
errorHandler.init();

// Initialize navigation guard to prevent throttling
navigationGuard.init();

// Initialize performance optimizations (only in production)
if (import.meta.env.PROD) {
  initPerformanceOptimizations();
  resourcePreloader.preloadAll();
}

// Initialize production logging
if (import.meta.env.PROD) {
  logger.info('app', 'Application starting in production mode');
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);